import React from 'react';

const PageLoader = ({
    message = 'Loading data...',
    fullscreen = false,
    overlay = false,
    className = '',
    id,
    style,
}) => (
    <div
        id={id}
        className={`page-loader${fullscreen ? ' page-loader--fullscreen' : ''}${overlay ? ' page-loader--overlay' : ''}${className ? ` ${className}` : ''}`}
        role="status"
        aria-live="polite"
        style={style}
    >
        <div className="page-loader-spinner" aria-hidden="true" />
        <div className="page-loader-message">{message}</div>
    </div>
);

export default PageLoader;
